
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import InputNumber from "components/InputNumber"

import FigureItem  from "components/FigureItem";
import NuCheckbox from "components/nubox/NuCheckbox"
import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
  
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class TablaNotasCentral extends React.Component {
  state = {

    modalImagen: false,
    
    fecha:'',
    bimestre:0,
    form: Object.assign({}, initialForm),

    dataList: [],/* lista  */
    //{"col":1, "label":'A1', 'id_asisfe':145 }
    
  };
   //---------------- CONTEXT API ------------------
    //const store = useStore();
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({dataList:[]});
    
    
    this.cargar_data();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    //let id_asisfe = this.props.params.id;

    let bimestre = this.props.params.id;
    this.setState({bimestre: bimestre})
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;              
      //------------------------------------------------

      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
      

    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  //-------------- cambiamos valor en la tabla
  handleCellChange=(index, columnId, value)=>{
    const newData = [...this.state.dataList];
    newData[index][columnId] = value;
    //this.setState({ datalist: newData });
    //solo tenemos que dejar pasar si es numero entero
    
    //console.log(value);
    if(value===""){
      this.setState({ datalist: newData });
      return;
    }
    //---------------------
    
    //----------------------
    let newData1 = this.calcular(newData, index);
    
    this.setState({ datalist: newData1 });
    
    //console.log(newData);
    //setData({  data: newData    });
    
  }
  //------------------------------------------
  //-------------------------
  calcular_totales=(tabla)=>{
    console.log("calcular_todos")
    const newData = [...tabla];
    console.log(newData)

    newData.map(( item, index) =>{
      this.calcular(newData,index )
    })
  }
  //------------------------------------------
  //--- solo calculamos la fila
  calcular=(newData, index)=>{
    console.log("calcular")
    const newData1 = [...this.state.dataList];

    //---------------------------------------    
    let b1_nota = newData[index]['b1_nota'];
    let b2_nota = newData[index]['b2_nota']; 
    let b3_nota = newData[index]['b3_nota'];  
    let b4_nota = newData[index]['b4_nota'];
    
    let promedio = parseInt(b1_nota) +parseInt(b2_nota)+parseInt(b3_nota)+parseInt(b4_nota);

    //--------------lo mismo para las practicas
    newData[index]["promedio"] = Math.round(promedio/4);
    //newData[index]["prom_practicas"] = prom_prac;
    
    let nota_final = Math.round(promedio/4);
    newData[index]["nota_final"] = nota_final;

    console.log(newData[index]["prueba_recu"])
    let prueba_recu = parseInt( newData[index]["prueba_recu"] )
    if(prueba_recu ===61){
      nota_final= 61;
      newData[index]["nota_final"] = nota_final;  //61  
    }


    newData[index]["obs"] = "REPROBADO";
    if( nota_final >=61){
      newData[index]["obs"] = "APROBADO";  
    }
    
    return newData1;
  }
  
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,

   */
  cargar_data=()=>{
    console.log("cargar_data")
    //let id_est = this.props.store.user.id_est;
    let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;
    let bimestre = parseInt( this.props.params.id);
    

    let param = { 
      id_mate: id_mate,
      id_peri: id_peri,
      bimestre: bimestre,
    }

    console.log(param)
    axios2.post("tabla_notas_central_get_list", param)
    .then(res => {
        console.log(res.data)
        if(res.data.tabla.length>0){ 
            this.setState({dataList: res.data.tabla,
              
            });

            this.calcular_totales(res.data.tabla)
        }else{
          this.setState({dataList: [] });
          
            //NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-----------------------------------------
  // retorna id_mate, nombre, sigla
  guardar_click=()=>{
    console.log("guardar_click");
    console.log("")
    
    this.save();
  }
  //---si el campo tiene valor vacio, lo convierte a 0
  normalizar=(num)=>{
    if(num==="") return 0;
    return num;
  }
  //-----------------------------------
  /*"id_progra": 36498,
    "p1": 0,
    "p2": 0,
    "p3": 0,
    "prom_parciales": 0,
    "practicas": 0,
    "prom_practicas": 0,
    "ex_final": 0,
    "prom_ex_final": 0,
    "nota_final": 0,*/
  /* normalizamos valores antes de enviar a el server */
  tabla_filter=()=>{
    const filteredBooks = [];
    this.state.dataList.forEach(filterValue => {
      filteredBooks.push({ "id_progra":filterValue.id_progra,
                          "promedio": filterValue.promedio,
                          "prueba_recu": filterValue.prueba_recu,
                          "nota_final": filterValue.nota_final,
                          "obs": filterValue.obs,
                          } );
    });
    return filteredBooks;
  }

  //-----------------------------------
  save =() =>{

    let param = { 
    
      tabla:  JSON.stringify( this.tabla_filter() )
      //tabla:  JSON.stringify( this.state.dataList )
    };

    //console.log( this.tabla_filter());
    
    
    axios2.post("tabla_notas_central_store", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            
            NotificationManager.success(res.data.men);    
            
            //redireccionar
            let bimestre = this.props.params.id;
            this.props.navigate('/tabla_notas_central_fin');       
        }else{
            NotificationManager.error(res.data.men);
            
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //-------------------------------------
  //------------------------------
  render() {
    let materia = this.props.store.materia
    let user = this.props.store.user
    return(
      <div>
        {/* ---   --- */}
        { 
          //JSON.stringify(this.state.form.cant_teo)
        }
        <div className="escritorio center-align p-3">

          <div className="row">
            <div className="col-md-7">
              <h3> PLANILLA DE NOTAS CENTRALIZADA { user.periodo } </h3>
              <Button 
                  className="btn btn-success" 
                  onClick={this.guardar_click  } >
                GUARDAR NOTAS
              </Button>
              &nbsp;
              
              <p>
                Sigla: { materia.sigla }<br />
                Materia: { materia.nombre } /G { materia.grupo } <br />
                Periodo: { user.periodo } <br />
                Bimestre: { this.state.bimestre } <br />
                { /* Fecha: { this.state.fecha }<br/> */}
              </p>
            </div>

            <div className="col-md-5">
             
            </div>

          </div>
        <div class="table-responsive">
          <table className="tabla_azul  table-striped table-hover ">
            <thead>
              <tr>
                <th rowSpan={2} className="text-center cell_celeste">Nro.</th>
                <th rowSpan={2} className="text-center cell_celeste">Apellidos y Nombres</th>
                <th rowSpan={2} className="text-center cell_celeste">C.I.</th>
                <th colSpan={3} className="cell_celeste">1er BIMESTRE</th>
                <th colSpan={3} className="cell_celeste">2er BIMESTRE</th>
                <th colSpan={3} className="cell_celeste">3er BIMESTRE</th>
                <th colSpan={3} className="cell_celeste">4er BIMESTRE</th>
                <th rowSpan={2} className="">PROMEDIO</th>
                <th rowSpan={2} className="">PORC. ASIS.</th>
                <th rowSpan={2} className="">PRUEBA RECUP.</th>
                <th rowSpan={2} className="">NOTA FINAL</th>
                <th rowSpan={2} className="">OBS</th>
              </tr>
              <tr>
                  {/*<th width="80px">Nro</th>*/}
                  {/*<th>Nro. Doc.</th>*/}
                  {/*<th>Apellidos y Nombres</th>*/}
                  {/*<th>C.I.</th>*/}
                  <th>Nota Teo.</th>
                  <th>Nota Prac.</th>
                  <th>Nota 1er Trim.</th>

                  <th>Nota Teo.</th>
                  <th>Nota Prac.</th>
                  <th>Nota 2do Trim.</th>
                  
                  <th>Nota Teo.</th>
                  <th>Nota Prac.</th>
                  <th>Nota 3er Trim.</th>

                  <th>Nota Teo.</th>
                  <th>Nota Prac.</th>
                  <th>Nota 4to Trim.</th>

                  {/*<td className="cell_rosado">Promedio</td>*/}
                  {/*<td className="cell_rosado">Proc. Asist.</td>*/}
                  {/*<td className="">Prueba Recupera.</td>*/}
                  {/*<th>Nota Final</th>*/}
                  {/*<th>Obs.</th>*/}
              </tr>
            </thead>
            <tbody>
                
                {this.state.dataList.map((item,index) => ( 
                    <tr key={index}>
                      <td>{ index+1 }
                        { /* item.id_progra */}
                      </td>
                      {/*<td>{ item.nro_doc }</td>*/}
                      <td>{ item.nomape_tmp }</td>
                      <td>
                        { item.nro_doc}
                      </td>
                      <td className="text-center"> {item.b1_nt} </td>
                      <td className="text-center"> {item.b1_np} </td>
                      <td className="text-center cell_rosado"> {item.b1_nota} </td>

                      <td className="text-center"> {item.b2_nt} </td>
                      <td className="text-center"> {item.b2_np} </td>
                      <td className="text-center cell_rosado"> {item.b2_nota} </td>

                      <td className="text-center"> {item.b3_nt} </td>
                      <td className="text-center"> {item.b3_np} </td>
                      <td className="text-center cell_rosado"> {item.b3_nota} </td>

                      <td className="text-center"> {item.b4_nt} </td>
                      <td className="text-center"> {item.b4_np} </td>
                      <td className="text-center cell_rosado"> {item.b4_nota} </td>

                      <td className="text-center "> {item.promedio} </td>
                      <td className="text-center "> {item.por_asis} </td>
                      <td className="text-center "> 
                        { item.promedio>=40 && item.promedio<=60?   
                          <InputNumber
                            type="text" 
                            className='' 
                            inputStyle={{width:50,  textAlign: 'center' }}
                            onChange={(e) => this.handleCellChange(index,"prueba_recu", e.target.value)} 
                            value={item.prueba_recu} 
                            max={61}
                            min={61}
                          />
                          :
                          <label>{ item.prueba_recu }</label>
                        }
                        
                      </td>
                      <td className="text-center "> {item.nota_final} </td>
                      <td className="text-center "> {item.obs} </td>
                      {/**------------------------------------- */}                                  
                    </tr>
                ))}
                
            </tbody>
          </table>
        </div>

        <div className="pt-2">
          <table width="80%" align="center" >
            <tbody>
              <tr>
                <td align="center">
                  
                </td>
              </tr>
            </tbody>
          </table>
        </div>


      </div>
        

        <NotificationContainer/>
      </div>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(TablaNotasCentral);